import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from '@carboledger/ui';
import { PageHeader } from '@/components/layout';
import { ROUTES } from '@/app/routes';
import { useTranslations } from '@/hooks';
import { ADMIN_TABS } from '../constants/admin.constants';
import { AccessManagerTable } from '../components/AccessManagerTable';
import { ActivityLogTable } from '../components/ActivityLogTable';
import styles from './AdminCentrePage.module.scss';

const TAB_ROUTES = Object.freeze({
  [ADMIN_TABS.accessManager]: ROUTES.admin,
  [ADMIN_TABS.activityLog]: ROUTES.activityLog,
});

export const AdminCentrePage = () => {
  const t = useTranslations();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeTab =
    pathname === ROUTES.activityLog ? ADMIN_TABS.activityLog : ADMIN_TABS.accessManager;

  const tabs = useMemo(
    () => [
      { value: ADMIN_TABS.accessManager, label: t('ADMIN_TAB_ACCESS_MANAGER') },
      { value: ADMIN_TABS.activityLog, label: t('ADMIN_TAB_ACTIVITY_LOG') },
    ],
    [t],
  );

  const handleTabChange = useCallback((tab) => navigate(TAB_ROUTES[tab]), [navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <PageHeader title={t('ADMIN_TITLE')} />
      </div>

      <div className={styles.tabs}>
        <Tabs
          tabs={tabs}
          value={activeTab}
          onChange={handleTabChange}
          aria-label={t('ADMIN_TITLE')}
        />
      </div>

      <div className={styles.content}>
        {activeTab === ADMIN_TABS.accessManager ? <AccessManagerTable /> : <ActivityLogTable />}
      </div>
    </div>
  );
};
